import React from 'react';

import { FloatingFlexArea, FloattingInnerArea } from './styles';

type FloatingBottomProps = {
  children: React.ReactNode;
};

const FloatingBottom = ({ children }: FloatingBottomProps) => {
  return (
    <FloatingFlexArea>
      <FloattingInnerArea>{children}</FloattingInnerArea>
    </FloatingFlexArea>
  );
};

export default FloatingBottom;
